export const MODULE_CODES = [
  'quality',
  'curriculum',
  'survey-feedback',
  'assessment',
  'course-exam-schedule',
  'academic-advising',
  'bap',
  'committee',
  'student-clearance',
  'graduate-card',
  'academic-workload',
  'analytics',
  'admin',
] as const

export type ModuleCode = typeof MODULE_CODES[number]

export type ModuleDefinition = {
  code: ModuleCode
  displayName: string
  defaultRoute: string
  primaryRoute: string
  aliases?: readonly string[]
}

export const MODULE_DEFINITIONS: readonly ModuleDefinition[] = [
  {
    code: 'quality',
    displayName: 'Kalite Güvence ve Akreditasyon',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/quality-pdca',
  },
  {
    code: 'curriculum',
    displayName: 'Müfredat ve Öğrenme Çıktıları',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/program-outcome-achievement',
  },
  {
    code: 'survey-feedback',
    displayName: 'Anket ve Geri Bildirim',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/survey-feedback',
  },
  {
    code: 'assessment',
    displayName: 'Ölçme ve Değerlendirme',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/my-course-exam',
  },
  {
    code: 'course-exam-schedule',
    displayName: 'Ders / Sınav Programı',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/university-course-schedule',
    aliases: ['dsos'],
  },
  {
    code: 'academic-advising',
    displayName: 'Akademik Danışmanlık',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/my-consultant-students',
  },
  {
    code: 'bap',
    displayName: 'Bilimsel Araştırma Projeleri',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/bap-project-applications',
  },
  {
    code: 'committee',
    displayName: 'Kurul ve Komisyon Yönetimi',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/committee',
  },
  {
    code: 'student-clearance',
    displayName: 'İlişik Kesme',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/student-clearance-request',
  },
  {
    code: 'graduate-card',
    displayName: 'Mezun Kartı',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/graduate-card',
  },
  {
    code: 'academic-workload',
    displayName: 'Ek Ders ve Akademik İş Yükü',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/additional-teaching',
  },
  {
    code: 'analytics',
    displayName: 'Yönetici Analitiği ve Kurumsal Raporlama',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/executive-report-dashboard',
  },
  {
    code: 'admin',
    displayName: 'Sistem Yönetimi',
    defaultRoute: '/module-dashboard',
    primaryRoute: '/applicationuser',
  },
]

const definitionsByCode = new Map<ModuleCode, ModuleDefinition>(
  MODULE_DEFINITIONS.map((definition) => [definition.code, definition])
)

const aliases = MODULE_DEFINITIONS.reduce<Record<string, ModuleCode>>((result, definition) => {
  result[definition.code] = definition.code
  definition.aliases?.forEach((alias) => {
    result[alias.toLocaleLowerCase('tr-TR')] = definition.code
  })
  return result
}, {})

export function canonicalizeModuleCode(value?: string | null): ModuleCode | undefined {
  if (!value) {
    return undefined
  }

  return aliases[value.trim().toLocaleLowerCase('tr-TR')]
}

export function getModuleDefinition(value?: string | null): ModuleDefinition | undefined {
  const code = canonicalizeModuleCode(value)
  return code ? definitionsByCode.get(code) : undefined
}

export function getConfiguredModuleCode(): ModuleCode | undefined {
  return canonicalizeModuleCode(process.env.REACT_APP_MODULE_CODE)
}
